/* TPS PDP redesign - product-page buy-box layout, built in JS so it works
   regardless of each template's block order or duplicate elements. Paired
   with tps-pdp-redesign.css. Fails safe: on any error the page keeps its
   default stacked layout. */
(function () {
  var CONT = '.product__info-container';

  /* Brand | reviews meta row, at the top right under the title */
  function buildMetaRow() {
    var cont = document.querySelector(CONT);
    if (!cont) return;
    if (cont.querySelector('.tps-meta-row')) return;
    var kids = cont.children, title = null, brand = null, rating = null, i, el;
    for (i = 0; i < kids.length; i++) {
      el = kids[i];
      if (!title && el.classList && el.classList.contains('product__title')) title = el;
      if (el.classList && el.classList.contains('product_page_brand_start_rating') && !el.querySelector('.tps-rp')) {
        if (!brand || (el.offsetParent !== null && el.textContent.trim())) brand = el;
      }
      if (!rating && el.querySelector && el.querySelector('.jdgm-widget')) rating = el;
    }
    if (!brand) return;
    var row = document.createElement('div');
    row.className = 'tps-meta-row';
    if (title && title.nextSibling) cont.insertBefore(row, title.nextSibling);
    else if (title) cont.appendChild(row);
    else cont.insertBefore(row, brand);
    row.appendChild(brand);
    if (rating) row.appendChild(rating);
  }

  /* Variation + quantity + Add-to-Cart on one row (right under the price).
     Only runs when the product actually has a variation dropdown; on
     no-variant products the quantity/ATC block is left exactly as-is. */
  function buildBuyRow() {
    var cont = document.querySelector(CONT);
    if (!cont) return;
    if (cont.querySelector('.tps-buy-row')) return;
    var variant = cont.querySelector(':scope > variant-selects');
    if (!variant) return;
    var qc = cont.querySelector(':scope > .product_page_quanitity_deliver_pincode');
    if (!qc) return;
    var row = document.createElement('div');
    row.className = 'tps-buy-row';
    cont.insertBefore(row, variant);
    row.appendChild(variant);
    row.appendChild(qc);
  }

  function run() { try { buildMetaRow(); buildBuyRow(); } catch (e) {} }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
})();
